import { QuoteBlock } from "./QuoteBlock";
import { ArgumentsTables, CoordsTable, NamingTable, MovesTable } from "./CustomTables";

const CUSTOM = {
  arguments: ArgumentsTables,
  coords: CoordsTable,
  naming: NamingTable,
  moves: MovesTable,
};

const Block = ({ block }) => {
  switch (block.type) {
    case 'p':
      return <p>{block.text}</p>;
    case 'sub':
      return (
        <h4 className="mb-4 mt-10 font-serif text-xl md:text-2xl font-semibold tracking-tight text-aegean">
          {block.text}
        </h4>
      );
    case 'ul':
      return (
        <ul className="mb-6 max-w-[68ch] list-disc space-y-3 pl-6 font-reading text-[1.02rem] leading-[1.8] text-foreground/90 marker:text-terra md:text-[1.12rem]">
          {block.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      );
    case 'quote':
      return <QuoteBlock greek={block.g} translation={block.t} cite={block.c} note={block.n} />;
    case 'custom': {
      const C = CUSTOM[block.kind];
      return C ? <C /> : null;
    }
    default:
      return null;
  }
};

export const Chapter = ({ chapter, compact = false }) => (
  <article id={chapter.id} data-testid={`chapter-${chapter.id}`} className={`prose-editorial scroll-mt-24 ${compact ? 'pt-12' : 'pt-14'}`}>
    <div className="mb-2 flex items-baseline gap-4">
      {chapter.num && (
        <span className="font-serif text-4xl md:text-5xl font-medium text-terra/80">{chapter.num}</span>
      )}
      <h3 className="font-serif text-2xl md:text-3xl font-semibold tracking-tight text-ink">
        {chapter.title}
      </h3>
    </div>
    <div className="mt-6">
      {chapter.blocks.map((b, i) => (
        <Block key={i} block={b} />
      ))}
    </div>
  </article>
);

export const PartHeading = ({ part }) => (
  <div id={part.id} data-testid={`part-${part.id}`} className="scroll-mt-24 border-t border-line pt-16 mt-24 first:mt-0 first:border-t-0 first:pt-0">
    <p className="eyebrow">{part.label}</p>
    <h2 className="mt-3 font-serif text-3xl md:text-4xl font-semibold tracking-tight text-ink">
      {part.title}
    </h2>
    {part.intro && (
      <p className="mt-4 max-w-[68ch] font-reading text-[1.02rem] leading-[1.8] text-muted-foreground md:text-[1.12rem]">
        {part.intro}
      </p>
    )}
  </div>
);
